define('constants/contactFilterByOptions',[], function() {
    return {
        companyAddressBook: "companyAddressBook",
        yourAddressBook: "yourAddressBook",
        trestaUserGroups: "trestaUserGroups"
    };
});
